<template>
    <fieldset>
        <div class="alert alert-warning">We are currently working behind the scenes to add more domain apis shortly.</div>
        <txt v-if="model.registrar" label="Registrar" v-model="model.registrar" readonly="true"></txt>
        <txt v-if="model.registrant" label="Registrant" v-model="model.registrant" readonly="true"></txt>
        <txt v-if="model.expiry" label="Expiry Date" v-model="model.expiry" readonly="true"></txt>
        <label>Nameservers:</label>
        <ul>
            <li v-for="nameserver in model.nameservers">{{ nameserver }}</li>
        </ul>
    </fieldset>

</template>
<script>
    export default{
        props: {
            name: { default : '' }
        },
        created() {
            this.$eventHub.$on('setWhois', this.setWhois);
        },
        methods: {
            setWhois(data) {
                this.model = this.$setData(data, this.model);
            },
        },
        // It's good to clean up event listeners before a component is destroyed.
        beforeDestroy () {
            this.$eventHub.$off('setWhois', this.setWhois);
        },
        data: function() {
            return {
                model: {
                    registrar: '',
                    registrant: '',
                    expiry: '',
                    nameservers: [],
                }
            };
        }
    }
</script>
